import { FC } from 'react';
import { CONTENT_RENDERS } from './configs';
import { IAppComponentProps } from './types';
import styles from './SchemaComponent.module.css';
import { Card, Flex } from 'antd';

export const SchemaComponent: FC<IAppComponentProps> = ({ ...props }) => {
	const { label, type, content } = props;

	// ! render
	return (
		<Card
			size='small'
			className={styles.schema_component}
		>
			<Flex
				vertical
				gap='small'
				className='w-100'
			>
				{label && <div style={{ overflow: 'hidden' }}>{label}</div>}

				<Flex
					gap='small'
					justify='center'
				>
					<div className={styles.template_representation_container}>
						{CONTENT_RENDERS[type]?.(content) ?? <>Mock not implemented</>}
					</div>
				</Flex>
			</Flex>
		</Card>
	);
};
